<template>
  <div class="num-paginatinon numpagination text-noselect gw_loading_text">
    <!-- <div
      @click="localPage = 1"
      class="icon_btn tbfttr_icon mdi mdi-chevron-double-left ml-auto"
      :class="{ 'no-events opacity_6': localPage === 1 }"
    ></div>
    <div
      @click="localPage = localPage - 1"
      class="icon_btn tbfttr_icon mdi mdi-chevron-left"
      :class="{ 'no-events opacity_6': localPage === 1 }"
    ></div>

    <div
      @click="localPage = localPage + 1"
      class="icon_btn tbfttr_icon mdi mdi-chevron-right"
      :class="{ 'no-events opacity_6': noNexTItem }"
    ></div> -->
    <!-- {{ offset }} -->
    <!-- {{ offset + limit }} -->
    <!-- {{ count }} -->
    <!-- {{ remaider }} -->
    <!-- {{ currentPage }} -->
    <!-- {{ lastPage }} -->
    <div
      v-if="visiblePages[0] !== 1"
      class="gw_btn"
      :class="{ 'gw_btn_active no-events': currentPage === 1 }"
      @click="handleClick(1)"
    >
      1
    </div>
    <div
      v-if="visiblePages[0] !== 1 && visiblePages[0] - 1 !== 1"
      class="icon_btn mdi text-normal mdi-chevron-left pa-1"
      @click="handleClick(currentPage - 1)"
    ></div>

    <div
      v-for="page in visiblePages"
      :key="page + currentPage"
      class="gw_btn"
      :class="{ 'gw_btn_active no-events': currentPage === page }"
      @click="handleClick(page)"
    >
      {{ page }}
    </div>

    <div
      v-if="
        currentPage !== numFixed(lastPage) &&
        visiblePages[visiblePages.length - 1] + 1 !== numFixed(lastPage) &&
        visiblePages.length === 3
      "
      class="icon_btn mdi text-normal mdi-chevron-right pa-1"
      @click="handleClick(currentPage + 1)"
    ></div>
    <div
      class="gw_btn"
      :class="{ 'gw_btn_active no-events': currentPage === numFixed(lastPage) }"
      @click="handleClick(lastPage)"
    >
      {{ numFixed(lastPage) }}
    </div>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'

export default {
  name: 'GwPagination',
  mixins: [format_mix],
  props: {
    limit: Number,
    offset: Number,
    count: Number,
  },
  emits: ['update:offset'],
  data() {
    return {}
  },
  methods: {
    handleClick(page) {
      let offset = this.numFixed(this.limit * (page - 1))
      if (offset >= this.count) {
        offset = this.count - this.remaider
      }
      if (this.offset === offset) return
      this.$emit('update:offset', offset)
    },
  },
  computed: {
    remaider() {
      return this.count % this.limit
    },
    currentPage() {
      return (this.offset + this.limit) / this.limit
    },
    lastPage() {
      return this.remaider !== 0 ? Math.floor(this.count / this.limit) + 1 : this.count / this.limit
    },

    visiblePages() {
      const cr = this.numFixed(this.currentPage)
      const lt = this.numFixed(this.lastPage)
      let res = [cr, cr + 1, cr + 2]

      res = res.map(i => (i === lt ? lt : i))
      res = res.filter(i => i < lt)
      if (res.length < 3) {
        const diff = 3 - res.length
        const prepend = [...new Array(diff).keys()].map((i, idx) => cr - idx - 1)
        prepend.reverse()
        res = [...prepend, ...res]
        // debugger
      } else if (res[0] !== 1) {
        res = res.map(i => i - 1)
      }
      res = res.filter(i => i > 0 && i < lt)
      // console.log(res)
      return res
    },
  },
}
</script>

<style lang="scss" scoped>
.numpagination {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
}
</style>
